/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Icon } from 'semantic-ui-react';
import { CardAttr } from '../widgets/card-attr';
import { t } from '../../locales/i18n';
import { deleteQueueAC } from '../../action-creators';
import EditItemDialog from '../dialogs/edit-item-dialog';
import QueueForm from '../forms/queue-form';
import confirmDialog from '../confirm-dialog';
import formatLastSeenOnline from '../../utils/format-last-seen-online';
import StatusLed from '../widgets/status-led';
import styled from 'styled-components';
import { colors } from '../../themes';

const Container = styled.div`
  padding: 1em;
  span.led {
    margin-right: 0.5em;
  }
`;

const Header = styled.section`
  display: grid;
  grid-template-columns: 1fr auto;
`;
const Actions = styled.div`
  i {
    cursor: pointer;
  }
  i.remove {
    color: ${colors.baseColors.red};
    margin-right: 0px;
  }
`;
const Content = styled.section`
  display: grid;
  grid-gap: 4px;
`;

function Title(props: any) {
  return (
    <span>
      <StatusLed status={props.status} redStatusName="closed" greenStatusName="open" />
      {props.name} ({props.status})
    </span>
  );
}

export default function QueueCard(props: any) {
  return (
    <>
      <Container>
        <Header>
          <h3>
            <Icon name="fast forward" />
            <Title {...props} />
          </h3>
          <Actions>
            <EditItemDialog form={QueueForm} {...props} />
            <Icon
              name="remove circle"
              onClick={() => confirmDialog(() => props.dispatch(deleteQueueAC(props._id)))}
              size="large"
            />
          </Actions>
        </Header>
        <Content>
          <CardAttr title="Number">{props.sequenceId}</CardAttr>

          <CardAttr title="Location">{props.location.name}</CardAttr>
          <CardAttr title="Priority">{props.priority}</CardAttr>
          <CardAttr title="Assigned Services">
            {props.services.map((s: any) => (
              <span key={s.id}>{`${s.name}`}, </span>
            ))}
          </CardAttr>
          <CardAttr title="Location">{props.location.name}</CardAttr>
          <CardAttr title="Remote checkin?">{props.allowRemoteCheckin ? 'yes' : 'no'}</CardAttr>
          <CardAttr title="Max check-ins per device">{props.maxCheckinsPerDevice}</CardAttr>
          <CardAttr title="Visible for mobile users?">{props.visibleForMobile ? 'yes' : 'no'}</CardAttr>
          <CardAttr title="n Queue Tickets">{props.tickets ? props.tickets.length : '?'}</CardAttr>
          <CardAttr title="CBX">
            {props.controlBox.uuid}
            {props.controlBox.connectionStatus === 'disconnected'
              ? `${t('last seen online')} : ${formatLastSeenOnline(props.controlBox.lastSeenOnline)}`
              : ''}
          </CardAttr>
        </Content>
      </Container>
    </>
  );
}
